<div class="row" (click)="onDialogClose()" class="fa fa-close close-icon"></div>
<br>
<div class="row viewer">
  <iframe *ngIf="contentType !== 'image'" [hidden]="!dataToDisplay" #fileViewer frameborder="0" class="file-viewer"
          [src]="dataToDisplay"></iframe>
  <img *ngIf="contentType === 'image'" class="image-viewer" [src]="dataToDisplay">
</div>


